<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.$session.start();
    console.log(this.version)
    // if (this.$route.fullPath === "/login") {
    //   if (localStorage.getItem("username") !== null) {
    //     this.$router.push("/homepage");
    //   }
    // } else {
    //   if (localStorage.getItem("username") === null && window.location.pathname !== '/kanpromool_management/newregist') {
    //     this.$router.push("/login");
    //   } 
    // }
  },
  data: () => ({}),
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
* {
  font-family: "Kanit", sans-serif !important;
}
body {
  height: 100%;
}
</style>
